import { render, staticRenderFns } from "./Sidebar__formReestr.vue?vue&type=template&id=47e07b7a&scoped=true&"
import script from "./Sidebar__formReestr.vue?vue&type=script&lang=js&"
export * from "./Sidebar__formReestr.vue?vue&type=script&lang=js&"
import style0 from "./Sidebar__formReestr.vue?vue&type=style&index=0&id=47e07b7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e07b7a",
  null
  
)

export default component.exports